import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: {
	collapseButtonWithLabel: MessageDescriptor;
	expandButtonWithLabel: MessageDescriptor;
} = defineMessages({
	expandButtonWithLabel: {
		id: 'atlassian-studio-ui-components.card.expandButtonWithLabel',
		defaultMessage: 'Expand {label}',
		description:
			'Accessible label for a button on an expandable card that includes the section name. When clicked, this button expands the card to show additional details or content that is currently hidden.',
	},
	collapseButtonWithLabel: {
		id: 'atlassian-studio-ui-components.card.collapseButtonWithLabel',
		defaultMessage: 'Collapse {label}',
		description:
			'Accessible label for a button on an expanded card that includes the section name. When clicked, this button collapses the card to hide the additional details or content.',
	},
});

export default messages;
